import type { FaireProductEntity } from "../../entity_types/product";

export const p_8u8zmu4h: FaireProductEntity = {
  token: "p_8u8zmu4h",
  type: "product",
  name: "Partysaurus Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1303a53594071c0552bff241c4c43f355378f0b3262af4ebad48fbf2d2047c28/1528335173.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/51863a984bb0d8a424ee430df6e1a16fcd551d4b574f3a6e4cd0afb84de3e962/1528335172.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:05.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
